<template>
  <line
    :x1 ="x"
    y1 = "0"
    :x2 = "x"
    :y2 = "getPipeEditorHeight"
    :style = "getLineColor"
    v-show="allowSplit"
    class="pen"
  />
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';

export default {
  name: 'Split',
  data () {
    return {
      x: 0
    };
  },
  mounted () {
    document.body.addEventListener('mousemove', this.handleMouseMove);
  },
  computed : {
    getPipeEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
    getLineColor () {
      return 'stroke:rgb(0,0,0);stroke-width:2';
    },
    allowSplit () {
      return useSegmentStore().getAllowSplit;
    }
  },
  methods : {
    handleMouseMove (e) {
      const segmentStore = useSegmentStore();
      if (segmentStore.getContextVisible) { return; }
      this.x = (e.pageX - document.body.clientWidth * .1) - useInputStore().getXAxisGap;
      segmentStore.setSplitX(this.x);
    },
  }
};
</script>

<style scoped>
.pe {
  pointer-events: auto;
}
.pen {
  pointer-events: none;
}
</style>